import React from 'react'
import Navbar from '../../layout/Navbar'
import "./Project.css"

const Dashboard = () => {
  return (
        <div >
      <div id='about-page'>
      <Navbar />
      <div id='about-hero'>
        <h5>PROJECTS</h5>
        <h2>SOME OF THE <span>WORK</span></h2>
        <p id='about-text'>Discover how Vwrap has helped numerous businesses achieve their outdoor marketing goals with our impressive portfolio of successful projects.</p>
      </div>
    </div>
    </div>
  )
}

export default Dashboard
